import { projectsApi } from '../../api/projects.ts';

/** A top-level task or subtask this project's tasks/subtasks flatten into, for a "which task is
 * this for" picker — subtasks are indented under their parent task's label. Shared by
 * ProjectProductsSection, ProjectEstimatesSection, and ProjectInvoicesSection. */
export interface TaskOption {
  id: string;
  label: string;
}

export async function loadTaskOptions(projectId: string): Promise<TaskOption[]> {
  const tasks = await projectsApi.listItems('project', projectId);
  const options: TaskOption[] = [];
  const subtasksByTask = await Promise.all(tasks.map((t) => projectsApi.listItems('task', t.id)));
  tasks.forEach((task, idx) => {
    options.push({ id: task.id, label: task.item });
    for (const subtask of subtasksByTask[idx] ?? []) {
      options.push({ id: subtask.id, label: `  └ ${subtask.item}` });
    }
  });
  return options;
}

export function taskLabel(taskOptions: TaskOption[], taskItemId: string | undefined): string {
  if (!taskItemId) return '—';
  return taskOptions.find((t) => t.id === taskItemId)?.label.trim() ?? '(deleted task)';
}
